import { SET_DRAWER_STATE, TOGGLE_DRAWER_STATE } from '../constants';

const setDrawerState = state => ({ type: SET_DRAWER_STATE, payload: state });
const toggleDrawerState = () => ({ type: TOGGLE_DRAWER_STATE });

const drawer = { setDrawerState, toggleDrawerState };

export default drawer;